import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { TagsServiceProvider } from '../../api/tags'

const TagsService = TagsServiceProvider()
const name = 'getEmployeesByTagId'

export default (tagId) => (asyncAction(
  name,
  TagsService.getEmployeesByTagId,
  { tagId }
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/tags/getEmployeesByTagId.js